import axios from 'axios';
import { CountryNumber, defaultCountries } from 'components/phoneInput/countries';
import { JsonResponse } from 'core/models/response';

let countries = [] as CountryNumber[];

interface CountriesResponse {
	country_codes: {
		[key: string]: string;
	};
	phone_country_codes: {
		[key: string]: string;
	};
}

export const getCountriesCode = async () => {
	if (countries.length > 0) return countries;

	try {
		const response = await axios.get<JsonResponse<CountriesResponse>>('register/country-codes');

		const formattedData: CountryNumber[] = Object.entries(response.data.data.country_codes).map(([key, value]) => ({
			isoCode: key,
			dialCode: value,
		}));

		countries = formattedData;

		return formattedData;
	} catch (error) {
		return defaultCountries;
	}
};
